import { computed, defineComponent, ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useMainStore } from '@/store/main/main'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'ApiDocsAnchors',
  setup() {
    const mainStore = useMainStore()
    const route = useRoute()
    const router = useRouter()
    let observer: IntersectionObserver | null = null

    const isMobile = computed(() => mainStore.isMobile)
    const activeAnchor = ref<string | null>(null)
    const isListOpen = ref(isMobile.value)

    const toggleIsListOpen = () => {
      if (!isMobile.value)
        return
      isListOpen.value = !isListOpen.value
    }

    const goToAnchor = (hash: string) => router.push({ hash })

    const observeAnchors = () => {
      if (!route.meta.nav)
        return

      if (observer)
        observer.disconnect()

      observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              activeAnchor.value = `#${entry.target.id}`
              break
            }
          }
        },
        {
          root: null,
          threshold: 0.6,
        },
      )

      route.meta.nav.forEach((navItem: any) => {
        const el = document.querySelector(navItem.to)
        if (el)
          observer!.observe(el)
      })
    }

    onMounted(() => {
      observeAnchors()
    })

    onBeforeUnmount(() => {
      if (observer)
        observer.disconnect()
    })

    watch(
      () => route.fullPath,
      () => {
        activeAnchor.value = null
        setTimeout(() => observeAnchors(), 100)
      },
    )
    return { isListOpen, isMobile, activeAnchor, toggleIsListOpen, goToAnchor }
  },
})
